import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spinner", "content"]
  static values = { url: String }

  connect() {
    // Lazy load content when element comes into view
    if (this.hasUrlValue) {
      this.loadContent()
    }
  }

  async loadContent() {
    if (this.isLoading) return

    this.isLoading = true
    this.showSpinner()

    try {
      const response = await fetch(this.urlValue, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (response.ok) {
        const html = await response.text()
        this.contentTarget.innerHTML = html
      }
    } catch (error) {
      // Error loading content
    } finally {
      this.hideSpinner()
      this.isLoading = false
    }
  }

  showSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('hidden')
    }
  }

  hideSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add('hidden')
    }
  }
} 